import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { GridComponent, AggregateService, GroupSettingsModel, PageSettingsModel, SelectionSettingsModel, ToolbarItems, ContextMenuItemModel } from '@syncfusion/ej2-angular-grids';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { MenuEventArgs  } from '@syncfusion/ej2-angular-navigations';

import { SharedFunctions } from '../../../../src/app/shared/shared.functions';
import { interval, Subscription } from 'rxjs';
import { takeWhile } from 'rxjs/operators';

import { MenuFuncionService, ExpensaService, TenantService, MovimientoService, UnidadFuncionalService, ConsorcioService, GastoService, TipoGastoService } from '../../../../src/app/shared/services';
import { MenuFuncionCodes, ExpensaLiquidacionResumenDto, SaveExpensaDto, LocalStorageKeys, TenantFeatureFlags, DialogConfirmRequest, SearchMovimientoItemDto } from '../../../../src/app/shared/model';
import { EstadoConstants, GridPageSettings, ConceptosRecargo, MetodoRedondeoExpensa, ConceptosRecargoConstants, TipoGasto, SearchTipoGastoRequest, DialogExpensaGastosPeriodoComponentRequestDto, DialogExpensaGastosPeriodoComponentResponseDto } from '../../../../src/app/shared/model';
import { DialogConfirmResponse, SearchMovimientoRequest, Movimiento, SaveUnidadFuncionalPersona, MetodoRedondeoExpensaEnum } from '../../../../src/app/shared/model';

import { DialogConfirmComponent } from '../../../../src/app/shared/components/modals/dialogConfirm.component';
import { DialogExpensaGastosPeriodoComponent } from './components/dialogExpensaGastosPeriodo.component';

@Component({
  selector: 'app-expensaEdit',
  templateUrl: './expensaEdit.component.html',
  styleUrls: ['./expensaEdit.component.css'],
  providers: [ AggregateService ]
})

export class ExpensaEditComponent implements OnInit {

  @ViewChild('ufGrid')
  public ufGrid: GridComponent;
  @ViewChild('gastosPeriodoGrid')
  public gastosPeriodoGrid: GridComponent;

  @ViewChild('gastosComunidadPeriodoGrid')
  public gastosComunidadPeriodoGrid: GridComponent;
  @ViewChild('gastosUfsPeriodoGrid')
  public gastosUfsPeriodoGrid: GridComponent;

  @ViewChild('deudasGrid')
  public deudasGrid: GridComponent;
  @ViewChild('pagosGrid')
  public pagosGrid: GridComponent;

  public pageSizes: number[];
  public pageSettings: PageSettingsModel;
  public ufGridPageSettings: PageSettingsModel;
  public ufGridAllowPaging: boolean = true;
  public gastosGridPageSettings: PageSettingsModel;
  public gastosGridAllowPaging: boolean = true;
  public gastosGridAllowGrouping: boolean = false;
  public gastosSelectionOptions: SelectionSettingsModel;
  public selectionOptions: SelectionSettingsModel;
  public toolbarOptions: ToolbarItems[];

  formGroup: FormGroup;
  public groupOptions: GroupSettingsModel;

  tenantFeatureFlags: TenantFeatureFlags;

  cantidadGastosTotalSeleccionado: number = 0;
  gastosTotalSeleccionado: number = 0;
  cantidadGastosComunidadTotalSeleccionado: number = 0;
  gastosComunidadTotalSeleccionado: number = 0;
  cantidadGastosUfTotalSeleccionado: number = 0;
  gastosUfTotalSeleccionado: number = 0;

  isValidating: boolean = false;
  isSearching: boolean = false;
  isSaving: boolean = false;
  isDeleting: boolean = false;
  isExporting: boolean = false;
  isSending: boolean = false;
  isDeudaSaving: boolean = false;
  isMovimientosPagoSearching: boolean = false;
  isMovimientosDeudasSearching: boolean = false;
  isConceptosRecargoSearching: boolean = false;
  isMetodosRedondeoExpensaSearching: boolean = false;
  isTiposGastosSearching: boolean = false;
  isEstadoChanging: boolean = false;
  isMovimientoRejecting: boolean = false;

  canEdit: boolean = false;
  canDelete: boolean = false;
  esUsuarioFinal: boolean = false;
  mostrarSeleccionConceptosRecargo: boolean = false;
  canMovimientoAdd: boolean = false;
  canMovimientoView: boolean = false;
  verSoloMovimientosDeudaActivos: boolean = true;
  canGastoView: boolean = false;

  ufTipoGastoPorcentajesFlexValue: number = 60;
  tipoGastosConceptosRecargoString: string;

  conceptosRecargoList: ConceptosRecargo[];
  metodosRedondeoExpensaList: MetodoRedondeoExpensa[];
  tiposGastosList: TipoGasto[];

  msgError: string = "";
  item: ExpensaLiquidacionResumenDto;

  movimientoPagoList: Movimiento[];
  movimientoDeudaList: Movimiento[];

  gastosComunidadPeriodoList: any[]; //SearchPendientesLiquidacionItem[];
  gastosUfPeriodoList: any[]; //SearchPendientesLiquidacionItem[];

  public ufGridContextMenuItems: ContextMenuItemModel[];
  public gastosComunidadGridContextMenuItems: ContextMenuItemModel[];
  public gastosUfsGridContextMenuItems: ContextMenuItemModel[];
  public deudasGridContextMenuItems: ContextMenuItemModel[];
  public pagosGridContextMenuItems: ContextMenuItemModel[];

  private ufGridWatcher: Subscription;

  private readonly ufGridColumns = [
    { field: 'UnidadFuncionalNumero', headerText: '#' },
    { field: 'UnidadFuncionalCodigo', headerText: 'Cód.' },
    { field: 'Propietario', headerText: 'Persona' },
    { field: 'Redondeo1', headerText: 'Redondeo' },
    { field: 'FondoOperativo', headerText: 'Fondo Operativo' },
    { field: 'TotalPrimerVencimiento', headerText: '1er. Venc.' },
    { field: 'TotalSegundoVencimiento', headerText: '2do. Venc.' },
    { field: 'PermitirGenerarInteres', headerText: 'Aplica Interés?' },
  ];

  private readonly gastosComunidadPeriodoGridColumns = [
    { field: 'Detalle', headerText: 'Detalle' },
    { field: 'TipoGasto', headerText: 'Tipo Gasto' },
    { field: 'ServicioGasto', headerText: 'Rubro' },
    { field: 'FechaGasto', headerText: 'Fecha' },
    { field: 'Importe', headerText: 'Importe' },
    { field: 'FechaVencimiento', headerText: 'Fecha Venc.' },
  ];

  private readonly gastosUfsPeriodoGridColumns = [
    { field: 'UnidadFuncionalCodigo', headerText: 'Cód. UF' },
    { field: 'Detalle', headerText: 'Detalle' },
    { field: 'TipoGasto', headerText: 'Tipo Gasto' },
    { field: 'ServicioGasto', headerText: 'Rubro' },
    { field: 'FechaGasto', headerText: 'Fecha' },
    { field: 'Importe', headerText: 'Importe' },
    { field: 'FechaVencimiento', headerText: 'Fecha Venc.' },
  ];

  private readonly deudasGridColumns = [
    { field: 'FechaMovimiento', headerText: 'Fecha' },
    { field: 'Detalle', headerText: 'Detalle' },
    { field: 'Estado', headerText: 'Estado' },
    { field: 'Monto', headerText: 'Monto' },
    { field: 'Saldo', headerText: 'Pendiente' }
  ];

  private readonly pagosGridColumns = [
    { field: 'FechaMovimiento', headerText: 'Fecha' },
    { field: 'TipoMovimientoNombre', headerText: 'Tipo' },
    { field: 'Detalle', headerText: 'Detalle' },
    { field: 'MedioPagoNombre', headerText: 'Medio Pago' },
    { field: 'Monto', headerText: 'Monto' }
  ];

  public ufColumnVisibility: { [key: string]: boolean } = {};

  constructor (
    private formBuilder: FormBuilder,
    private router: Router,
    public dialog: MatDialog,
    private sharedFunctions: SharedFunctions,
    private route: ActivatedRoute,
    private menuService: MenuFuncionService,
    private tenantService: TenantService,
    private consorcioService: ConsorcioService,
    private tipoGastoService: TipoGastoService,
    private gastoService: GastoService,
    private movimientoService: MovimientoService,
    private unidadFuncionalService: UnidadFuncionalService,
    private expensaService: ExpensaService
  ) {
  }

  ngOnInit(): void {
    this.isValidating = true;
    this.menuService.checkMenuPadre(MenuFuncionCodes.EXPENSA).subscribe(data => {
      if (data != null && data.Success && data?.Result != null && data.Result.length > 0) {
        this.tenantService.getTenantFeatureFlagsById(this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.TenantId)).subscribe(dataTenant => {
          this.isValidating = false;

          if (dataTenant != null && dataTenant.Success)
            this.tenantFeatureFlags = dataTenant.Result;

          this.canEdit = data.Result.some(x => x == MenuFuncionCodes.EXPENSA_EDIT);
          this.canDelete = data.Result.some(x => x == MenuFuncionCodes.EXPENSA_DELETE);

          this.esUsuarioFinal = this.sharedFunctions.esUsuarioFinal();

          this.loadView();
        },
        (err: HttpErrorResponse) => {
          this.isValidating = false;
          this.sharedFunctions.handleError(err, true);
        })
      }
      else {
        this.isValidating = false;
        this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
        this.router.navigate(['/']);
      }
    },
    (err: HttpErrorResponse) => {
      this.isValidating = false;
      this.sharedFunctions.handleError(err, true);
    });
  }

  initializeContextMenus() {
    this.ufGridContextMenuItems = this.sharedFunctions.initializeContextMenu(this.ufGridColumns);

    //Solo inicializo los context menu de las grillas que se ven cuando se carga la vista
    this.gastosComunidadGridContextMenuItems = this.sharedFunctions.initializeContextMenu(this.gastosComunidadPeriodoGridColumns);
    this.deudasGridContextMenuItems = this.sharedFunctions.initializeContextMenu(this.deudasGridColumns);
  }

  onGastosPeriodoTabChange(event: any): void {
    if (event.index === 1) {
      //Tab de Gastos de UFs
      if (this.gastosUfsPeriodoGrid != null) {
        this.gastosUfsGridContextMenuItems = this.sharedFunctions.initializeContextMenu(this.gastosUfsPeriodoGridColumns);
        this.gastosUfsPeriodoGrid.refresh();
      }
    }
    else if (event.index === 0) {
      //Tab de Gastos de Comunidad
      if (this.gastosComunidadPeriodoGrid != null) {
        this.gastosComunidadGridContextMenuItems = this.sharedFunctions.initializeContextMenu(this.gastosComunidadPeriodoGridColumns);
        this.gastosComunidadPeriodoGrid.refresh();
      }
    }
  }

  onMovimientosTabChange(event: any): void {
    if (event.index === 1) {
      //Tab de Movimientos de Pagos
      if (this.pagosGrid != null) {
        this.pagosGridContextMenuItems = this.sharedFunctions.initializeContextMenu(this.pagosGridColumns);
        this.pagosGrid.refresh();
      }
    }
    else if (event.index === 0) {
      //Tab de Movimientos de Deuda
      if (this.deudasGrid != null) {
        this.deudasGridContextMenuItems = this.sharedFunctions.initializeContextMenu(this.deudasGridColumns);
        this.deudasGrid.refresh();
      }
    }
  }

  loadView() {
    this.pageSizes = GridPageSettings.PageSizeList;

    this.pageSettings = { pageCount: GridPageSettings.PageCount, pageSize: this.pageSizes[1], pageSizes: this.pageSizes };
    this.ufGridPageSettings = { pageCount: GridPageSettings.PageCount, pageSize: this.pageSizes[1], pageSizes: this.pageSizes };
    this.gastosGridPageSettings = { pageCount: GridPageSettings.PageCount, pageSize: this.pageSizes[1], pageSizes: this.pageSizes };

    this.buildForm();
    this.loadEntity();

    this.getConceptosRecargo();
    this.getMetodosRedondeoExpensa();
    this.getTiposGastos();

    this.setPermissions();
    this.initializeContextMenus();

    this.groupOptions = { showDropArea: false, columns: [ 'ServicioGasto' ] };

  }

  setPermissions() {
    this.menuService.checkMenuPadre(MenuFuncionCodes.MOVIMIENTO).subscribe(data => {
      if (data != null && data.Success && data?.Result) {
        this.canMovimientoAdd = data.Result.some(x => x == MenuFuncionCodes.MOVIMIENTO_DEUDA);
        this.canMovimientoView = data.Result.some(x => x == MenuFuncionCodes.MOVIMIENTO_LIST);
      }
    },
    (err: HttpErrorResponse) => {
      this.sharedFunctions.handleError(err);
    });

    this.menuService.checkMenuPadre(MenuFuncionCodes.GASTO).subscribe(data => {
      if (data != null && data.Success) {
        this.canGastoView = data.Result != null && data.Result.length > 0;
      }
    },
    (err: HttpErrorResponse) => {
      this.sharedFunctions.handleError(err);
    });
  }

  buildForm() {
    this.formGroup = this.formBuilder.group({
      'FechaVencimiento': [null, Validators.required],
      'FechaVencimiento2': [null, Validators.required],
      'Observaciones': [null, Validators.maxLength(300)],
      'ImporteFondoOperativo': [0, Validators.required],
      'InteresVencimiento': [null],
      'InteresMensual': [null],
      'ConceptosRecargo': [null],
      'MetodoRedondeoExpensa': [null],
      'TipoGastosConceptosRecargo': [null],
      'NotaExpensas': [null, Validators.maxLength(1000)],
      'NotaExpensasPie': [null, Validators.maxLength(1000)]
    });
  }

  isProcessing() {
    return (this.isSearching || this.isSaving || this.isDeleting || this.isSending || this.isExporting || this.isEstadoChanging);
  }

  getConceptosRecargo() {
    this.isConceptosRecargoSearching = true;
    this.consorcioService.getConceptosRecargo().subscribe(data => {
      this.isConceptosRecargoSearching = false;
      if (data != null)
        this.conceptosRecargoList = data?.Result;
    },
    (err: HttpErrorResponse) => {
      this.isConceptosRecargoSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getMetodosRedondeoExpensa() {
    this.isMetodosRedondeoExpensaSearching = true;
    this.consorcioService.getMetodosRedondeoExpensa().subscribe(data => {
      this.isMetodosRedondeoExpensaSearching = false;
      if (data != null)
        this.metodosRedondeoExpensaList = data?.Result;
    },
    (err: HttpErrorResponse) => {
      this.isMetodosRedondeoExpensaSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  compareTipoGastos(o1: number, o2: number): boolean {
    return o1 == o2;
  }

  getTiposGastos() {
    var r = new SearchTipoGastoRequest(null, null, true, "Nombre", null, null, null, null, true);
    this.isTiposGastosSearching = true;

    this.tipoGastoService.search(r).subscribe(data => {
      this.isTiposGastosSearching = false;
      if (data != null)
        this.tiposGastosList = data?.result;
    },
      (err: HttpErrorResponse) => {
        this.isTiposGastosSearching = false;
        this.sharedFunctions.handleError(err);
      });
  }

  loadEntity() {
    this.route.params.subscribe(params => {
      if (params['id'] != null && params['id'] != '0') {
        var id = Number(params['id']);

        if (id > 0) {
          this.isSearching = true;
          this.expensaService.getResumenLiquidacion(id).subscribe(data => {
            this.isSearching = false;
            
            if (data != null && data.Success) {
              this.item = data.Result;
              if (this.item != null && this.item.ExpensaCabecera != null) {
                this.canEdit = this.canEdit && this.item.ExpensaCabecera.Editable;
                this.canDelete = this.canDelete && this.item.ExpensaCabecera.Editable;

                this.ufTipoGastoPorcentajesFlexValue = 65 / (this.item.TiposGasto.length * 2);
                this.formGroup.patchValue(this.item.ExpensaCabecera);

                this.formGroup.get("TipoGastosConceptosRecargo")?.setValue(this.item.ExpensaCabecera?.TipoGastosConceptosRecargo?.map(item => item?.TipoGastoId));
                this.tipoGastosConceptosRecargoString = this.item.ExpensaCabecera?.TipoGastosConceptosRecargo?.map(item => item?.TipoGasto).join(', ');
                this.onConceptoRecargoChange();

                if (!this.esUsuarioFinal) {
                  this.getMovimientoPagos(this.item.ExpensaCabecera?.Id);
                  this.getMovimientoDeudas(this.item.ExpensaCabecera?.Id);
                }

                this.gastosComunidadPeriodoList = (this.item.GastosPeriodo as any[])?.filter(f => f.UnidadFuncionalId == null);
                this.gastosUfPeriodoList = (this.item?.GastosPeriodo as any[])?.filter(f => f.UnidadFuncionalId > 0);
                this.updateGastoPeriodoTotal();

                this.generateDynamicGridColumns();
              }
              else
                this.msgError = "No se encontró la expensa seleccionada.";
            }
            else
              this.msgError = "Ocurrió un error al intentar obtener los datos de la expensa.";
          },
          (err: HttpErrorResponse) => {
            this.isSearching = false;
            this.sharedFunctions.handleError(err, true);
          })
        }
        else
          this.msgError = "Item no válido.";
      }
      else
      {
        this.sharedFunctions.showMessage("Debe seleccionar una expensa para continuar", "Error");
        this.onCancel();
      }
    });
  }

  updateGastoPeriodoTotal() {
    this.gastosTotalSeleccionado = 0;
    this.cantidadGastosTotalSeleccionado = 0;
    this.gastosComunidadTotalSeleccionado = 0;
    this.cantidadGastosComunidadTotalSeleccionado = 0;
    this.gastosUfTotalSeleccionado = 0;
    this.cantidadGastosUfTotalSeleccionado = 0;

    var itemList = this.gastosComunidadPeriodoList;
    if (itemList != null && itemList.length > 0) {
      this.gastosComunidadTotalSeleccionado = (itemList?.reduce(function (accumulator, item) {
        return accumulator + (item?.Importe ?? 0);
      }, 0) ?? 0);
    }

    var itemList2 = this.gastosUfPeriodoList;
    if (itemList2 != null && itemList2.length > 0) {
      this.gastosUfTotalSeleccionado = (itemList2?.reduce(function (accumulator, item) {
        return accumulator + (item?.Importe ?? 0);
      }, 0) ?? 0);
    }

    this.gastosTotalSeleccionado = this.gastosComunidadTotalSeleccionado + this.gastosUfTotalSeleccionado;

    this.cantidadGastosComunidadTotalSeleccionado = (itemList?.length ?? 0);
    this.cantidadGastosUfTotalSeleccionado = (itemList2?.length ?? 0);
    this.cantidadGastosTotalSeleccionado = (itemList?.length ?? 0) + (itemList2?.length ?? 0);
  }

  getErrorNombre() {
    var v = this.formGroup.get('Nombre');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 100 caracteres alcanzado';
    return '';
  }

  getErrorTipo() {
    return this.formGroup.get('TipoNombre')?.hasError('required') ? 'El campo es obligatorio' :'';
  }

  onGridActionFailure(event: any): void {
    this.sharedFunctions.showMessage("Ocurrió un error intentando realizar la búsqueda", "Error");
  }

  sumUfPorcentaje(gastoId: number) {
    var v = this.item?.UfsLiquidacion?.reduce(function (accumulator, item) {
        var val = item.Valores.filter(x => x.TipoGastoId == gastoId).reduce(function (accum, g) { return accum + g.Porcentaje; }, 0);
        return accumulator + val;
      }, 0);

    return (v ?? 0);
  }

  sumUfImporte(gastoId: number) {
    var v = this.item?.UfsLiquidacion?.reduce(function (accumulator, item) {
        var val = item.Valores.filter(x => x.TipoGastoId == gastoId).reduce(function (accum, g) { return accum + g.Importe; }, 0);
        return accumulator + val;
      }, 0);

    return (v ?? 0);
  }

  onConceptoRecargoChange() {
    this.mostrarSeleccionConceptosRecargo =
      (this.canEdit && this.formGroup.get("ConceptosRecargo")?.value == ConceptosRecargoConstants.GastosSeleccionados) ||
      (!this.canEdit && this.item.ExpensaCabecera.ConceptosRecargo == ConceptosRecargoConstants.GastosSeleccionados);
  }

  getErrorFechaVencimiento() {
    var v = this.formGroup.get('FechaVencimiento');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    return '';
  }

  getErrorFechaVencimiento2() {
    var v = this.formGroup.get('FechaVencimiento2');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    return '';
  }

  getErrorImporteFondoOperativo() {
    var v = this.formGroup.get('ImporteFondoOperativo');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    return '';
}

  getErrorObservaciones() {
    var v = this.formGroup.get('Observaciones');
    if (v?.hasError('maxlength'))
      return 'Límite de 300 caracteres alcanzado';
    return '';
  }

  getNotaExpensas() {
    var v = this.formGroup.get('NotaExpensas');
    if (v?.hasError('maxlength'))
      return 'Límite de 1000 caracteres alcanzado';
    return '';
  }

  getNotaExpensasPie() {
    var v = this.formGroup.get('NotaExpensasPie');
    if (v?.hasError('maxlength'))
      return 'Límite de 1000 caracteres alcanzado';
    return '';
  }

  invitarPersona(item: any) {
    if (item != null && item.PuedeEnviarInvitacion) {

      var r = new SaveUnidadFuncionalPersona(0,
        item.UnidadFuncionalId,
        item.UnidadFuncionalNumero,
        item.PersonaId,
        item.Propietario,
        "", "", 0, "", true, true, false, "", false
      );

      this.unidadFuncionalService.sendNewUserInvitation(r).subscribe(data => {
        if (data.Success && data.Result == true) {
          this.sharedFunctions.showMessage("Se envió correctamente un correo de invitación al correo configurado", "Operación Exitosa!");
          item.PuedeEnviarInvitacion = false;
        }
        else {
          this.sharedFunctions.showMessage("Ocurrió un error enviando el mail de invitación al usuario.", "Error");
        }
      },
      (err: HttpErrorResponse) => {
        this.sharedFunctions.handleError(err, true);
      });
    }
  }

  permitirGenerarIntereses(item: any) {

    if (item != null) {
      this.gastoService.permitirGenerarInteres(item.GastoId, !item.PermitirGenerarInteres).subscribe(data => {
        if (data.Success && data.Result == true) {
          var index = this.item.UfsLiquidacion.findIndex(f => f.GastoId == item.GastoId);
          if (index >= 0) {
            this.item.UfsLiquidacion[index].PermitirGenerarInteres = !item.PermitirGenerarInteres;
            this.ufGrid.refresh();

            this.getMovimientoDeudas(this.item.ExpensaCabecera?.Id);
          }
        }
        else {
          this.sharedFunctions.showMessage("Ocurrió un error enviando el mail de invitación al usuario.", "Error");
        }
      },
      (err: HttpErrorResponse) => {
        this.sharedFunctions.handleError(err, true);
      });
    }
  }

  onGuardar() {

    if (!this.formGroup.valid) {
      this.sharedFunctions.showMessage("Por favor complete todos los datos obligatorios para continuar", "Error");
      return false;
    }

    var r = new SaveExpensaDto(0, true, null, new Date(), null, 0, 0, 0, 0, [], 0, null, null);
    r = {
      ...this.formGroup.value,
      ...{
        Id: (this.item?.ExpensaCabecera?.Id ?? 0),
        Activo: this.item.ExpensaCabecera.Activo
      }
    };

    this.isSaving = true;
    this.expensaService.save(r).subscribe(data => {
      this.isSaving = false;
      if (data != null && data.Success && data.Result != null && data.Result.Id > 0) {
        this.sharedFunctions.showMessage("Se guardaron correctamente los datos!", "Operación Exitosa!");
        this.sharedFunctions.reloadCurrentRoute();
      }
      else
        this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
    },
    (err: HttpErrorResponse) => {
      this.isSaving = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  onDelete() {
    if (!this.canDelete)
      return;

    if (this.item?.ExpensaCabecera != null && this.item.ExpensaCabecera.Id > 0) {
      const dialogRef = this.dialog.open(DialogConfirmComponent, {
        data: new DialogConfirmRequest("Confirmación de Baja", "¿Está seguro que desea dar de baja la expensa?", "Sí", "No")
      });

      dialogRef.afterClosed().subscribe((result: DialogConfirmResponse) => {
        if (result != null && result.Accepted) {
          this.isDeleting = true;
          this.expensaService.delete(this.item.ExpensaCabecera.Id).subscribe(data => {
            this.isDeleting = false;
            if (data != null && data.Success) {
              this.onCancel();
            }
            else
              this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
          },
          (err: HttpErrorResponse) => {
            this.isDeleting = false;
            this.sharedFunctions.handleError(err, true);
          })
        }
      });
    }
    else
      this.sharedFunctions.showMessage("Debe cargar un gasto para poder llevar a cabo la operación", "Error");
  }

  onCancel() {
    this.router.navigate(['expensa-list']);
  }

  onDocumentPrint() {

    if (this.item == null || this.item.ExpensaCabecera == null || this.item.ExpensaCabecera.Id == null || this.item.ExpensaCabecera.Id <= 0) {
      this.sharedFunctions.showMessage("Debe seleccionar una expensa para continuar con la operación", "Error");
      return false;
    }

    this.isExporting = true;
    this.expensaService.createLiquidacionDocument(this.item.ExpensaCabecera.Id).subscribe((data: Blob) => {
      this.isExporting = false;
      var fileUrl = URL.createObjectURL(data);

      var anchor = document.createElement("a");
      anchor.download = "ExpensaLiquidacion_" + this.item?.ExpensaCabecera?.ComunidadNombre + "_" + this.item.ExpensaCabecera.ExpensaPeriodo + ".pdf";
      anchor.href = fileUrl;
      anchor.click();
    },
    (err: HttpErrorResponse) => {
      this.isExporting = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  onDocumentSend() {
    if (this.item == null || this.item.ExpensaCabecera == null || this.item.ExpensaCabecera.Id == null || this.item.ExpensaCabecera.Id <= 0) {
      this.sharedFunctions.showMessage("Debe seleccionar una expensa para continuar con la operación", "Error");
      return false;
    }

    this.isSending = true;
    this.expensaService.sendLiquidacionDocument(this.item.ExpensaCabecera.Id).subscribe(data => {
      this.isSending = false;
      if (data.Success)
        this.sharedFunctions.showMessage("Se envió éxitosamente la liquidación de expensa a los correos configurados!", "Operación Exitosa!");
    },
    (err: HttpErrorResponse) => {
      this.isSending = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  estaPublicada() {
    return (this.item?.ExpensaCabecera?.EstadoId == EstadoConstants.ESTADO_EXPENSA_PUBLICADA);
  }

  onEstadoChange() {
    if (this.item == null || this.item.ExpensaCabecera == null || this.item.ExpensaCabecera.Id == null || this.item.ExpensaCabecera.Id <= 0) {
      this.sharedFunctions.showMessage("Debe seleccionar una expensa para continuar con la operación", "Error");
      return false;
    }

    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      data: new DialogConfirmRequest(
        "Confirmación de Operación",
        "¿Está seguro que desea " + (this.estaPublicada() ? "poner en borrador" : "publicar") + " la expensa?",
        "Sí", "No")
    });

    dialogRef.afterClosed().subscribe((result: DialogConfirmResponse) => {
      if (result != null && result.Accepted) {
        if (this.estaPublicada()) {
          this.isEstadoChanging = true;
          this.expensaService.borrador(this.item.ExpensaCabecera.Id).subscribe(data => {
            this.isEstadoChanging = false;
            if (data.Success) {
              this.sharedFunctions.showMessage("Se envió éxitosamente a borrador la expensa!", "Operación Exitosa!");
              this.sharedFunctions.reloadCurrentRoute();
            }
            else
              this.sharedFunctions.showMessage("Ocurrió un error intentando realizar la operación", "Error");
          },
          (err: HttpErrorResponse) => {
            this.isEstadoChanging = false;
            this.sharedFunctions.handleError(err, true);
          })
        }
        else {
          this.isEstadoChanging = true;
          this.expensaService.publicar(this.item.ExpensaCabecera.Id).subscribe(data => {
            this.isEstadoChanging = false;
            if (data.Success) {
              this.sharedFunctions.showMessage("Se publicó éxitosamente la expensa!", "Operación Exitosa!");
              this.sharedFunctions.reloadCurrentRoute();
            }
            else
              this.sharedFunctions.showMessage("Ocurrió un error intentando realizar la operación", "Error");
          },
          (err: HttpErrorResponse) => {
            this.isEstadoChanging = false;
            this.sharedFunctions.handleError(err, true);
          })
        }
      }
    });
  }

  editGastosPeriodo() {
    if (!this.canEdit)
      return;

    if (this.item?.ExpensaCabecera != null && this.item.ExpensaCabecera.Id > 0) {

      if (this.estaPublicada()) {
        this.sharedFunctions.showMessage("La expensa se encuentra publicada y no se le pueden realizar modificaciones en los gastos", "Error");
        return false;
      }

      const dialogRef = this.dialog.open(DialogExpensaGastosPeriodoComponent, {
        data: new DialogExpensaGastosPeriodoComponentRequestDto(
          this.item.ExpensaCabecera,
          this.item.GastosPeriodo
        )
      });

      dialogRef.afterClosed().subscribe((result: DialogExpensaGastosPeriodoComponentResponseDto) => {
        if (result != null && !result.Cancelled) {
          this.sharedFunctions.reloadCurrentRoute();
        }
      });
    }
    else
      this.sharedFunctions.showMessage("Debe cargar un gasto para poder llevar a cabo la operación", "Error");
  }

  onWheel(event: WheelEvent) {
    (event.target as HTMLElement).blur();
    event.preventDefault();
  }

//#region Movimientos

  getMovimientoDeudas(id: number) {
    //Busco solamente las deudas asociadas a esta expensa, no importa si estan Canceladas (esto ultimo es porque cuando se genera una nueva expensa de mes
    //  posterior, las deudas de la expensa anterior se cancelan para que solo queden las deudas de la nueva expensa generada)
    var r = new SearchMovimientoRequest(null, null, true, "FechaMovimiento", null, null, null, null, null, null, null, null, null, null, null, null,
      null, -1, null, null, null, id, null, null, null, null, null, null, null, null, null, this.verSoloMovimientosDeudaActivos, null, null);
    this.isMovimientosDeudasSearching = true;

    this.movimientoService.search(r).subscribe(data => {
      this.isMovimientosDeudasSearching = false;
      this.movimientoDeudaList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isMovimientosDeudasSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getMovimientoPagos(id: number) {
    //Busco solamente los pagos asociados a esta expensa
    var r = new SearchMovimientoRequest(null, null, true, "FechaMovimiento", null, null, null, null, null, null, null, null, null, null, null, null,
      null, 1, null, null, null, id, null, null, null, null, null, null, null, null, null, true, null, null);
    this.isMovimientosPagoSearching = true;

    this.movimientoService.search(r).subscribe(data => {
      this.isMovimientosPagoSearching = false;
      this.movimientoPagoList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isMovimientosPagoSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  puedeVerMovimiento() {
    return (this.item?.ExpensaCabecera != null && this.item.ExpensaCabecera?.Id > 0 && this.tenantFeatureFlags?.HabilitarControlCaja && this.canMovimientoView);
  }

  getEstadoBackgroundColor(item: SearchMovimientoItemDto) {
    return (item != null && item.EstadoId == EstadoConstants.ESTADO_MOVIMIENTO_CANCELADO ? 'indianred' : 'black');
  }

  getTotalMovimientosPagos() {
    var v = this.movimientoPagoList?.reduce(function (accumulator, item) {
      return accumulator + (item?.Monto ?? 0);
    }, 0);

    return (v ?? 0);
  }

  getTotalMovimientosPendientes() {
    var v = this.movimientoDeudaList?.filter(f => f.EstadoId == EstadoConstants.ESTADO_MOVIMIENTO_CONFIRMADO)?.reduce(function (accumulator, item) {
      return accumulator + ((item?.Saldo ?? 0) * -1);
    }, 0);

    return (v ?? 0);
  }

  getTotalMovimientosDeudas() {
    var v = this.movimientoDeudaList?.filter(f => f.EstadoId == EstadoConstants.ESTADO_MOVIMIENTO_CONFIRMADO)?.reduce(function (accumulator, item) {
      return accumulator + ((item?.Monto ?? 0) * -1);
    }, 0);

    return (v ?? 0);
  }

  tieneMovimientoAsociado() {
    return (this.item != null && this.item.ExpensaCabecera.Id > 0 && this.tenantFeatureFlags?.HabilitarControlCaja && this.canMovimientoView);
  }

  viewMovimiento(item: any) {
    if (!item || item.Id == null || item.Id <= 0) {
      this.sharedFunctions.showMessage("Debe seleccionar un item", "Error");
      return false;
    }

    if (!this.canMovimientoView) {
      this.sharedFunctions.showMessage("No tiene permisos para llevar a cabo la operación", "Error");
      return false;
    }

    this.router.navigate(['movimiento-view', item.Id]);
  }

  viewExpensa(id: number) {
    if (id == null || id <= 0) {
      this.sharedFunctions.showMessage("Debe seleccionar una expensa", "Error");
      return false;
    }

    //Para forzar la recarga del componente (sino no lo recarga y falla la carga de los contextmenu)
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(['expensa-edit/'+id]);
    });
  }

  onMovimientoReject(item: SearchMovimientoItemDto) {
    if (item == null || item.Id == null || item.Id <= 0 || !item.PuedeRechazar)
        return false;

    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      data: new DialogConfirmRequest(
        null,
        "¿Está seguro que desea cancelar el movimiento?<br/><br/>" +
          "<b>Una vez cancelado, el movimiento no podrá volver a ser restaurado.</b>",
        "Sí, cancelar de todas formas",
        "No"
      )
    });

    dialogRef.afterClosed().subscribe((result: DialogConfirmResponse) => {
      if (result != null && result.Accepted) {
        this.isMovimientoRejecting = true;
        this.movimientoService.cancelar(item.Id).subscribe(data => {
          this.isMovimientoRejecting = false;
          if (data != null && data.Success && data.Result) {
            this.sharedFunctions.showMessage("Se canceló correctamente el movimiento!", "Operación Exitosa!");
            this.getMovimientoPagos(this.item.ExpensaCabecera?.Id);
          }
          else
            this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
        },
        (err: HttpErrorResponse) => {
          this.isMovimientoRejecting = false;
          this.sharedFunctions.handleError(err, true);
        })
      }
    });
  }

//#endregion

  formatRedondeo(): string {
    if (this.item?.ExpensaCabecera?.MetodoRedondeoExpensa === MetodoRedondeoExpensaEnum.RedondeoPorDecimal)
      return '1.4-4';
    return '1.2-2';
  }

  pageUfGrid() {
    this.ufGridAllowPaging = !this.ufGridAllowPaging;
  }

  pageGastosGrid() {
    this.gastosGridAllowPaging = !this.gastosGridAllowPaging;
  }

  groupGastosGrid() {
    this.gastosGridAllowGrouping = !this.gastosGridAllowGrouping;
  }

  onViewGasto(id: number) {
    if (id == null || id <= 0) {
        this.sharedFunctions.showMessage("Debe seleccionar un item", "Error");
        return false;
    }

    if (!this.canGastoView) {
        this.sharedFunctions.showMessage("No tiene permisos para llevar a cabo la operación", "Error");
        return false;
    }

    this.router.navigate(['gasto-edit', id]);
  }

  generateDynamicGridColumns() {

    if (this.tenantFeatureFlags?.HabilitarControlCaja) {
      const cashColumns = [
        { field: 'SaldoAnterior', headerText: 'Saldo Ant.' },
        { field: 'PagosAnterior', headerText: 'Pagos Ant.' },
        { field: 'SaldoGeneral', headerText: 'Saldo' },
        { field: 'Intereses', headerText: 'Interés' }
      ];
      this.ufGridColumns.push(...cashColumns);
    }


    if (this.item?.TiposGasto && this.item.TiposGasto.length > 0) {
      const expenseColumns : any = this.item.TiposGasto
      expenseColumns.forEach(gasto => {
        if(gasto.MostrarEnResumenExpensa) {
          this.ufGridColumns.push(
                    {
                      field: `Porcentaje-${gasto.TipoGastoId}`,
                      headerText: `% ${gasto.TipoGasto}`
                    }
                  )
        }
        this.ufGridColumns.push(
                    {
                      field: `Importe-${gasto.TipoGastoId}`,
                      headerText: `Gastos ${gasto.TipoGasto}`
                    }
                  )

      })
    }

   // Inicializar el menú contextual.
    this.ufGridContextMenuItems = this.sharedFunctions.initializeContextMenu(this.ufGridColumns);

  // Hacer visibles todas las columnas por defecto.
    this.initializeColumnVisibility(this.ufGridColumns, this.ufColumnVisibility);
  }

  initializeColumnVisibility(
    columns: { field: string; headerText: string }[],
    visibilityColumn: { [key: string]: boolean }
  ): void {
    columns.forEach(column => {
      visibilityColumn[column.field] = true;
    });
  }

  ufGridContextMenuOpen(args: any): void {
    args.cancel = this.sharedFunctions.updateMenuItemState(args.items,args.event.target, this.ufGrid, this.ufGridColumns);
  }

  ufGridContextMenuClick(args: MenuEventArgs): void {
    if (!args.item.id) return;
    const { id } = args.item;
    this.sharedFunctions.setColumnsVisibility(id, this.ufGrid, this.ufGridColumns, null, this.ufColumnVisibility)
  }

  gastosComunidadGridContextMenuOpen(args: any): void {
    args.cancel = this.sharedFunctions.updateMenuItemState(args.items,args.event.target, this.gastosComunidadPeriodoGrid, this.gastosComunidadPeriodoGridColumns);
  }

  gastosComunidadGridContextMenuClick(args: MenuEventArgs): void {
    if (!args.item.id) return;
    const { id } = args.item;
    this.sharedFunctions.setColumnsVisibility(id, this.gastosComunidadPeriodoGrid, this.gastosComunidadPeriodoGridColumns)
  }

  gastosUfsGridContextMenuOpen(args: any): void {
    args.cancel = this.sharedFunctions.updateMenuItemState(args.items,args.event.target, this.gastosUfsPeriodoGrid, this.gastosUfsPeriodoGridColumns);
  }

  gastosUfsGridContextMenuClick(args: MenuEventArgs): void {
    if (!args.item.id) return;
    const { id } = args.item;
    this.sharedFunctions.setColumnsVisibility(id, this.gastosUfsPeriodoGrid, this.gastosUfsPeriodoGridColumns)
  }

  deudasGridContextMenuOpen(args: any): void {
    args.cancel = this.sharedFunctions.updateMenuItemState(args.items,args.event.target, this.deudasGrid, this.deudasGridColumns);
  }

  deudasGridContextMenuClick(args: MenuEventArgs): void {
    if (!args.item.id) return;
    const { id } = args.item;
    this.sharedFunctions.setColumnsVisibility(id, this.deudasGrid, this.deudasGridColumns)
  }

  pagosGridContextMenuOpen(args: any): void {
    args.cancel = this.sharedFunctions.updateMenuItemState(args.items,args.event.target, this.pagosGrid, this.pagosGridColumns);
  }

  pagosGridContextMenuClick(args: MenuEventArgs): void {
    if (!args.item.id) return;
    const { id } = args.item;
    this.sharedFunctions.setColumnsVisibility(id, this.pagosGrid, this.pagosGridColumns)
  }
}
